export default function buildRecordTypes(coverages) {
  let recordTypeNames = ''
  if (Array.isArray(coverages)) {
    const recordTypes = coverages.reduce((acc, cov) => {
      if (cov?.recordType?.name) {
        acc.push(cov.recordType.name)
      }
      return acc
    }, [])

    recordTypeNames = [...new Set(recordTypes)].sort().join(', ')
  }

  return recordTypeNames
}
